<template>
    <v-container fluid>
        <v-layout align-center>
            <v-flex>
                <div class="headline mb-2">
                    Tilbud
                </div>
            </v-flex>
            <v-flex>
                <v-text-field class="pb-2" v-model="search" append-icon="mdi-magnify" label="Søk..." single-line
                              hide-details outlined dense/>
            </v-flex>
            <v-flex/>
            <v-flex shrink>
                <v-btn color="green" dark :to="{name: 'CreateOffer'}" class="mb-3">
                    <v-icon left>add</v-icon>
                    Nytt tilbud
                </v-btn>
            </v-flex>
        </v-layout>
        <v-progress-linear indeterminate v-if="loading"/>
        <v-data-table :headers="headers" :items="offers" v-else class="elevation-1 table-condensed" hide-default-footer
                      :items-per-page="-1" sort-by="id" sort-desc :search="search" :custom-filter="customFilter">
            <template v-slot:body="{ items }">
                <tbody>
                <tr v-for="offer in items" :key="offer.id" @click="goToOffer(offer)">
                    <td class="text-right font-weight-bold">{{ offer.id }}</td>
                    <td>{{ offer.customer_name }}</td>
                    <td>{{ offer.description }}</td>
                    <td>{{ formatDate(offer.date) }}</td>
                    <td>{{ formatDate(offer.valid_until) }}</td>
                    <td>kl. {{ formatTime(offer.modified) }}</td>
                    <td>{{ offer.our_ref_name }}</td>
                    <td class="text-right">{{ offer.project }}</td>
                    <td class="text-right">{{ formatMoney(offer.sum) }}</td>
                </tr>
                <tr v-if="!items.length">
                    <td colspan="3">Ingen tilbud funnet.</td>
                </tr>
                </tbody>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
    import {formatDate, formatMoney, formatNumber, formatTime} from "../helpers";

    export default {
        data() {
            return {
                loading: false,
                search: '',
                offers: []
            }
        },

        created() {
            this.loadData();
        },

        methods: {
            formatMoney,
            formatNumber,
            formatTime,
            formatDate,
            loadData() {
                this.loading = true;
                this.$http.get(`offers/`).then(response => {
                    this.offers = response.data;
                }).finally(() => {
                    this.loading = false;
                });
            },
            goToOffer(offer) {
                this.$router.push({name: 'EditOffer', params: {id: offer.id}});
            },
            customFilter(value, search, item) {
                let searchValue = [];
                Object.keys(item).forEach(key => {
                    if (typeof item[key] === 'string' || typeof item[key] === 'number') {
                        searchValue.push((''+item[key]).toLowerCase());
                    }
                });
                return searchValue.join(' ').indexOf(search.toLowerCase()) !== -1;
            }
        },

        computed: {
            headers() {
                return [
                    {text: 'Tilbudsnr.', value: 'id', align: 'right', width: '120px'},
                    {text: 'Kunde', value: 'customer_name'},
                    {text: 'Kort beskrivelse', value: 'description'},
                    {text: 'Dato', value: 'date'},
                    {text: 'Gyldig til', value: 'valid_until'},
                    {text: 'Sist endret', value: 'modified'},
                    {text: 'Vår ref.', value: 'our_ref_name'},
                    {text: 'Prosjektnr.', value: 'project', align: 'right'},
                    {text: 'Sum (eks. mva)', value: 'sum', align: 'right'}
                ]
            }
        }
    }
</script>